import { render, staticRenderFns } from "./NumberItem.vue?vue&type=template&id=114c1604&scoped=true&"
import script from "./NumberItem.vue?vue&type=script&lang=js&"
export * from "./NumberItem.vue?vue&type=script&lang=js&"
import style0 from "./NumberItem.vue?vue&type=style&index=0&id=114c1604&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c1604",
  null
  
)

export default component.exports